import { Center, Flex, Spinner } from "@chakra-ui/react";
import React, { useState } from "react";
import { MapRef, NavigationControl } from "react-map-gl/maplibre";

import { MapDeckGl } from "@nens/deck-gl";

import { useGmwGeojsonQuery } from "@/queries/query-gmw";

import { GmnFilterLegend } from "./components/gmn-filter-legend";
import { MapMarker } from "./components/map-marker";
import { SetMap } from "./components/set-map";
import { useBackgroundLayer } from "./hooks/use-background-layer";
import { BackgroundMap, BackgroundMapPicker } from "./hooks/use-background-picker";
import { useScatterplotLayer } from "./hooks/use-scatterplot-layer";
import { useViewState } from "./hooks/use-view-state";

import "./css/main-map.css";

export const MAP_TILER_API_KEY = "bztTf7OUHw34SX6rNKFe";

const initialViewState = {
  latitude: 52.1009166,
  longitude: 5.6462914,
  zoom: 6.5,
  pitch: 0,
  bearing: 0,
};

const MainMap: React.FC = () => {
  const [backgroundMap, setBackgroundMap] = useState<BackgroundMap>("topographic");
  const [dragging, setDragging] = useState<boolean>(false);
  const [map, setMap] = useState<MapRef | null>(null);

  useViewState(map);
  const backgroundLayer = useBackgroundLayer(backgroundMap);
  const scatterplotLayer = useScatterplotLayer();

  const { isLoading } = useGmwGeojsonQuery();

  return (
    <Flex
      width="full"
      borderStyle="solid"
      borderLeftWidth="1px"
      borderBottomWidth="1px"
      borderTopWidth="40px"
      borderColor="accent"
      pos="relative"
    >
      {isLoading && (
        <Center
          h="full"
          w="full"
          position="absolute"
          top={0}
          left={0}
          zIndex={2000}
          bg="rgba(0, 0, 0, 0.4)"
          pointerEvents="none"
        >
          <Spinner color="white" boxSize={20} />
        </Center>
      )}

      <MapDeckGl
        mapProps={{
          // Street, country etc labels
          mapStyle: `https://api.maptiler.com/maps/ec479fb9-0511-4946-8089-c75f12503486/style.json?key=${MAP_TILER_API_KEY}`,
          initialViewState,
        }}
        deckGlProps={{
          layers: [backgroundLayer, scatterplotLayer],
          pickingRadius: 5,
          useDevicePixels: false,
          onDragStart: () => setDragging(true),
          onDragEnd: () => setDragging(false),
          getCursor: ({ isHovering }: { isHovering: boolean }) => {
            const cursorStyle = (() => {
              if (isHovering) return "pointer";
              if (dragging) return "grabbing";
              return "grab";
            })();
            if (map) map.getCanvas().style.cursor = cursorStyle;
            return cursorStyle;
          },
        }}
      >
        <SetMap setMap={setMap} />
        <MapMarker />

        <GmnFilterLegend />

        <BackgroundMapPicker
          backgroundMap={backgroundMap}
          setBackgroundMap={setBackgroundMap}
        ></BackgroundMapPicker>

        <NavigationControl position="bottom-right" />
      </MapDeckGl>
    </Flex>
  );
};

export { MainMap };
